<template>
  <el-dialog title="报警信息详情"
             v-dialogDrag
             :visible.sync="detailVisible"
             width="700px"
             append-to-body
             class="fire-detail-continer">
    <div class="detail-info-body">
      <el-form stripe>
        <div class="detail">
          <h3 class="detailTitle">基本信息</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="告警类型："
                            class="col">
                <span :class="showColor( detailData.commonAlarmType)">{{detailData.commonAlarmType | dic("SENU097003004")}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备告警类型："
                            class="col">
                {{queryAlarmType(detailData.alarmType)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警时间："
                            class="col">
                {{ detailData.alarmTime | moment }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警级别："
                            class="col">
                <span :class="alarmColor(detailData.alarmLevel)">
                  {{detailData.alarmLevel | dic("SENU017")}}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="告警描述："
                            class="col"
                            v-if="detailData.subSystem=='13'">
                {{detailData.desc}}
              </el-form-item>
              <el-form-item label="告警描述："
                            class="col"
                            v-else>
                <span v-if="detailData.desc">{{detailData.desc}}</span>
                <span v-else>
                  <span v-if="detailData.buildingName && detailData.buildingName">在{{ detailData.buildingName }}位置,{{detailData.subDeviceMark | dic("SENU094")}}上报
                    <span v-if="detailData.commonAlarmType"
                          :class="showColor(detailData.commonAlarmType)">{{detailData.commonAlarmType | dic("SENU097003004")}}</span>
                  </span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="process-detail">
          <h3 class="detailTitle">告警详情</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="主机类型（厂商）："
                            class="col">
                {{detailData.deviceType | dic("SENU087")}}
                <span v-if="detailData.deviceType || detailData.parentFactoryName || detailData.factoryName">(</span>
                {{ detailData.subDeviceMark ? detailData.parentFactoryName : detailData.factoryName }}
                <span v-if="detailData.deviceType || detailData.parentFactoryName || detailData.factoryName">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主机名称（编号）："
                            class="col">
                {{ detailData.subDeviceMark ? detailData.parentDeviceName : detailData.deviceName }}
                <span v-if="detailData.parentDeviceName || detailData.deviceName || detailData.parentThirdAlarmDevId">(</span>
                {{detailData.parentThirdAlarmDevId}}
                <span v-if="detailData.parentDeviceName || detailData.deviceName || detailData.parentThirdAlarmDevId">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部件名称："
                            class="col">
                {{ detailData.subDeviceMark ? detailData.deviceName : ''}}
                <span v-if="detailData.componentThirdAlarmDevId && detailData.deviceName">(</span>
                {{detailData.componentThirdAlarmDevId}}
                <span v-if="detailData.componentThirdAlarmDevId && detailData.deviceName">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部件编号："
                            class="col">
                {{ detailData.thirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="唯一标识号："
                            class="col">
                {{ detailData.thirdDeviceId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回路："
                            class="col">
                {{ detailData.loopThirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分机号："
                            class="col">
                {{ detailData.childThirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警："
                            class="col">
                {{ detailData.multiAlarmType | dic('SENU100') }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警所在位置："
                            class="col">
                {{ detailData.buildingName }}
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 楼栋基本信息 -->
          <el-row>
            <el-col :span="24">
              <div @click="isExpand = !isExpand"
                   class="col">
                <span style="color:#2a65ff;cursor:pointer;">楼栋基本信息</span>
                <el-button type="text"
                           style="margin-right: 25px;font-size: 16px;margin-top:7px;color: #2a65ff;"
                           :class="['iconfont-lunan icon-lunan-xiaosanjiaodown',isExpand ? 'icon-transform' : '']">
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-collapse-transition>
            <el-row v-if="isExpand">
              <el-col :span="24">
                <el-form-item label="楼栋管理员：">
                  {{buildingPerson}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="安全员："
                              class="col">
                  {{ securityPersonnel }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备用安全员："
                              class="col">
                  {{ securityPersonnel }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="值班主机："
                              class="col">
                  {{ alternatePersonnel }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-transition>
        </div>

        <div class="process-detail">
          <h3 class="detailTitle">处理详情</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="处理人员："
                            class="col">
                {{ detailData.modifierName || detailData.modifier }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理时间："
                            class="col">
                {{ detailData.modifyTime | moment }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警处置状态："
                            class="col">
                {{ queryHandleStatus(detailData.alarmState) }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理描述："
                            class="col">
                {{ detailData.processDesc }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

  </el-dialog>
</template>
<script>
import { API } from '../api'
import { Dates, Bus, Dic, Base, Cache } from "$utils";
export default {
  data () {
    return {
      detailVisible: false,
      alarmId: '',
      buildingPerson: '',
      securityPersonnel: '',
      alternatePersonnel: '',
      isExpand: false,
      detailData: {}
    }
  },
  watch: {
  },
  methods: {
    open (id) {
      this.detailVisible = true;
      this.alarmId = id;
      this.getAlarmDetail()
    },
    getAlarmDetail () {
      this.buildingPerson = '';
      this.securityPersonnel = '';
      this.alternatePersonnel = ''
      let params = {
        alarmId: this.alarmId
      }
      this.$fetch(API.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.detailData = response.returnObj;
          // 两点报警列表
          // this.relationAlarmInfoList = response.returnObj.relationAlarmInfoList
          // thirdAlarmDevId主机编号-分机编号-回路-部件编号（部件地址）
          if (this.detailData.buildingPersonnel && this.detailData.buildingPersonnel.personnelName) {
            this.buildingPerson = this.detailData.buildingPersonnel.personnelName + '(' + this.detailData.buildingPersonnel.personnelPhone + ')'
          }
          if (this.detailData.securityPersonnelList && this.detailData.securityPersonnelList.length) {
            this.detailData.securityPersonnelList.forEach((item, index) => {
              this.securityPersonnel += item.personnelName + '(' + item.personnelPhone + ')、'
            })
            this.securityPersonnel = this.securityPersonnel.substring(0, this.securityPersonnel.lastIndexOf("、"));
          }
          if (this.detailData.alternatePersonnelList && this.detailData.alternatePersonnelList.length) {
            this.detailData.alternatePersonnelList.forEach((item, index) => {
              this.alternatePersonnel += item.personnelName + '(' + item.personnelPhone + ')、'
            })
            this.alternatePersonnel = this.alternatePersonnel.substring(0, this.alternatePersonnel.lastIndexOf("、"));
          }
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      })
    },
    showColor (val) {
      if (val == '4001') {
        return 'colorRed'
      } else if (val == "4002") {
        return 'colorYellow'
      } else if (val == "4005" || val == "4008" || val == "4009" || val == "40099") {
        return 'colorBlue'
      } else if (val == '130103') {
        return 'colorYellow'
      } else if (val == '130101') {
        return 'colorRed'
      } else {
        return ''
      }
    },
    alarmColor (level) {
      level = parseInt(level);
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    queryAlarmType (value) {
      if (value && value.substr(0, 1) == '4') {
        //报警类型
        return Dic.findByValue("SENU004004", Number(value));
      } else {
        //报警类型
        return Dic.findByValue("SENU004013", Number(value));
      }
    },
    //处理状态
    queryHandleStatus (value) {
      return Dic.findByValue("SENU068", Number(value));
    },
  }
}
</script>
<style lang="scss">
.fire-detail-continer {
  .colorRed {
    color: red !important;
  }
  .colorYellow {
    color: #ffbf00 !important;
  }
  .colorBlue {
    color: #2a65ff !important;
  }

  .icon-transform {
    transform: rotate(180deg);
  }
  .instancy {
    color: #ff4547;
  }

  .severity {
    color: #ff466e;
  }

  .general {
    color: #ffbf00;
  }
  .common {
    color: #2a65ff;
  }

  .detail-info-body {
    height: 400px;
    overflow-y: auto;
    .detailTitle {
      height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
      font-size: 15px;
      font-weight: bold;
      // vertical-align: center;
    }
    .col {
      margin-top: -20px;
    }
  }
}
</style>